{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Sonuç bulunamadı.",
    "SEARCH_PLACEHOLDER": "Ara...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Ara...",
    "EMPTY_STATE": "Sonuç bulunamadı.",
    "SEARCHING": "Aranıyor..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "İptal Et",
      "CONFIRM": "Onayla"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Ülke ismi giriniz",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Lütfen listeden bir döner kod seçin"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Yazar uygun değil"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Daha Fazla",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Dakika",
    "HOURS": "Saat",
    "DAYS": "Gün",
    "PLACEHOLDER": "Süre girin"
  },
  "CHANNEL_SELECTOR": {
    "COMING_SOON": "Çok yakında!"
  },
  "SLASH_COMMANDS": {
    "HEADING_1": "Heading 1",
    "HEADING_2": "Heading 2",
    "HEADING_3": "Heading 3",
    "BOLD": "Bold",
    "ITALIC": "Italic",
    "STRIKETHROUGH": "Strikethrough",
    "CODE": "Code",
    "BULLET_LIST": "Bullet List",
    "ORDERED_LIST": "Ordered List",
    "TABLE": "Table",
    "IMAGE": "Image"
  }
}
